import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTrigger,
} from "@/components/ui/dialog";
import { SelectLoggedUser } from "@/redux/Auth";
import { useAppDispatch, useAppSelector } from "@/redux/store";
import { getCookie } from "cookies-next";
import Image from "next/image";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import close from "@/public/images/close.svg";
import PaymentTabs from "../PaymentTabs";
import defaultImage from "@/public/images/default_image.jpg";
import USER from "@/redux/User";
import SweetAlert from "../SweetAlert";

type Props = {
  teacher: any;
};

const SubscribeWithTeacher: React.FC<Props> = ({ teacher }) => {
  const dispatch = useAppDispatch();

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const loggedUser = useAppSelector(SelectLoggedUser);
  const [subscribeWithTeacherTabIndex, setSubscribeWithTeacherTabIndex] =
    useState<number>(1);
  const [send, setSend] = useState(false);

  useEffect(() => {
    const token = getCookie("Education_User_token");
    if (token || loggedUser.isUserLogged || loggedUser.userToken) {
      setIsUserLoggedIn(true);
    } else {
      setIsUserLoggedIn(false);
    }
  }, [loggedUser]);

  const handleDialogOpen = () => {
    if (!isUserLoggedIn) {
      // toast.error("قم بتسجيل الدخول لتستطيع الشراء");
      SweetAlert({
        title: "حدث خطأ",
        text: "قم بتسجيل الدخول لتستطيع الشراء",
        iconName: "error",
        buttonText: "حسنا",
      });
    } else if (!teacher.user_subscribed_teacher) {
      setIsDialogOpen(true);
    }
  };

  const handleSubscribeWithTeacherSubmit = (
    teacher_id: number,
    type: number
  ) => {
    setSend(true);
    const formData = new FormData();
    formData.append("teacher_id", teacher_id.toString());
    formData.append("type", type.toString());

    dispatch(USER.thunks.doSubscribeWithTeacher({ data: formData })).then(
      (res: any) => {
        if (subscribeWithTeacherTabIndex === 1) {
          if (res.meta.requestStatus === "fulfilled") {
            let idInterval: number | null = null;

            const funCheck = (): void => {
              console.log("res33333", res);
              dispatch(
                USER.thunks.doCheckInvoice({
                  invoice_id: res.payload.data.invoice_id,
                })
              ).then(async (checkRes) => {
                console.log("checkRes222222222222", res);

                if (checkRes.meta.requestStatus === "fulfilled") {
                  if (checkRes.payload.data.link) {
                    console.log(
                      "checkRes.payload.data.link",
                      checkRes.payload.data.link
                    );
                    console.log(
                      "checkRes.payload.data.checkInvoice111",
                      checkRes.payload.data.checkInvoice
                    );
                    window.location.href = checkRes.payload.data.link;
                    // window.open(checkRes.payload.data.link, "_self");
                    // toast.success("تم إنشاء الطلب بنجاح");
                    SweetAlert({
                      title: "عملية ناجحة",
                      text: "تم إنشاء الطلب بنجاح",
                      iconName: "success",
                      buttonText: "حسنا",
                    });
                    // if (checkRes.payload.data.link) {
                    //   const win = window.open("");
                    //   if (win) {
                    //     win.location.href = checkRes.payload.data.link;
                    //   }
                    // }

                    // Clear the interval after success
                    if (idInterval !== null) {
                      clearInterval(idInterval);
                    }
                    setSend(false);
                  }
                }
              });
            };

            // Set the interval and store its ID
            idInterval = window.setInterval(funCheck, 2000);
            // const win = window.open("");
            // if (win) {
            //   win.location.href = res.payload.data.link;
            // } else {
            //   toast.error("ادفع الفاتوره من خلال صفحة الاشتراكات");
            // }
          }
        }
        dispatch(USER.thunks.doGetSingleTeachers({ id: teacher.id })).then(() =>
          setIsDialogOpen(false)
        );
      }
    );
  };

  if (teacher.user_subscribed_teacher) {
    return (
      <p className="text-16 font-[600] text-primaryColor py-[20px] px-[32px] rounded-[10px] border border-primaryColor block text-center">
        انت مشترك مع هذا المدرس
      </p>
    );
  }

  return (
    <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <DialogTrigger onClick={handleDialogOpen}>
        <p className="text-16 font-[600] text-[#202225] py-[20px] px-[32px] rounded-[10px] bg-primaryColor block text-center">
          اشترك الان مع هذا المدرس
        </p>
      </DialogTrigger>

      {isUserLoggedIn && (
        <DialogContent className="bg-[#323538] border-none overflow-auto">
          <div className="flex items-center justify-between gap-5 p-[25px] bg-[#474A4D] rounded-t-xl">
            <div>
              <p className="text-18 text-white font-[500]">
                الاشتراك مع المدرس
              </p>
            </div>
            <DialogClose>
              <Image src={close} alt="close" />
            </DialogClose>
          </div>
          <div className="p-[25px]">
            <div className="flex flex-col items-center justify-center gap-2">
              <Image
                src={teacher.image || defaultImage}
                alt="instructor"
                width={200}
                height={200}
                className="object-contain w-[200px] h-[200px] rounded-[10px] mx-auto"
              />
              <p className="text-18 text-white font-[500]">
                <span className="text-primaryColor">مستر </span>
                {teacher?.name}
              </p>
            </div>
            <PaymentTabs
              tabIndex={subscribeWithTeacherTabIndex}
              setTabIndex={setSubscribeWithTeacherTabIndex}
              send={send}
              item={{
                price: teacher.subscription_price,
                id: teacher.id,
              }}
              walletCharge={true}
              handleSubmit={handleSubscribeWithTeacherSubmit}
              codeMethod={false}
            />
          </div>
        </DialogContent>
      )}
    </Dialog>
  );
};

export default SubscribeWithTeacher;
